import ArrowRightIcon from '@/common/assets/icons/arrowRightIcon.svg?react';
import BazdidIcon from '@/common/assets/icons/bazdidIcon.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import TimeSetModal, {
  SetTimeFormType,
} from '@/common/components/scheduleVisitListComponent/TimeSetModal';
import { useCreateTimeSetQueryOptions } from '@/common/queries/createTimeSet/createTimeSetQueryOptions';
import { getCulpritTimeSetQueryOptions } from '@/common/queries/getCulpritTimeSet/getCulpritTimeSetQueryOptions';
import { getTimeSetsQueryOptions } from '@/common/queries/getTimeSets/getTimeSetsQueryOptions';
import { convertPersianToGregorian } from '@/common/utils/convertPersianToGregorian';
import convertTimestampToShamsi from '@/common/utils/convertTimestampToShamsi';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

const VisitTimeSet = ({ userType }: { userType?: 'culprit' | 'damaged' }) => {
  const { id, damagedId } = useParams();
  const [open, setOpen] = useState(false);
  const { mutate } = useCreateTimeSetQueryOptions();
  const { data: fileList } = useQuery(
    getTimeSetsQueryOptions({
      fileId: id!,
      enableGetFileList: true,
    }),
  );
  const { data: culpritTimeSet, refetch } = useQuery(
    getCulpritTimeSetQueryOptions({
      id: id!,
      damage_id: damagedId!,
      user_type: 'culprit',
    }),
  );
  const onSubmitForm = (data: SetTimeFormType) => {
    mutate(
      {
        data: {
          adjuster_visit_date: convertPersianToGregorian(
            data.adjuster_visit_date,
          ),
          damages: userType
            ? userType === 'damaged'
              ? fileList
                  ?.filter((item) => item.id === +damagedId!)
                  .map((item) => ({
                    user_type: item.user_type.const,
                    id: item.id,
                  }))
              : [
                  {
                    user_type: 'culprit',
                    id: 0,
                  },
                ]
            : undefined,
          adjuster_visit_time: data.adjuster_visit_time,
          visit_location: data.visit_location,
          visit_location_phi: null,
          visit_location_lambda: null,
        },
        id: id!,
      },
      {
        onSuccess: () => {
          setOpen(false);
          refetch();
        },
      },
    );
  };
  return (
    <Flex
      dir="row"
      gap={'37px'}
      justify="space-between"
      align="center"
      bg={'white'}
      px={'35px'}
      py={'16px'}
      borderRadius={'8px'}
      shadow="cardShadow"
    >
      <TimeSetModal
        open={open}
        closeModal={() => setOpen(false)}
        onSubmitForm={(data) => {
          onSubmitForm(data);
        }}
      />
      <Box flexBasis={'33%'}>
        <BazdidIcon className={css({ width: '100%', height: '100%' })} />
      </Box>
      <Box
        display={'flex'}
        justifyContent={'center'}
        flexDirection={'column'}
        alignItems={'center'}
        flexBasis={'80%'}
        gap={'10px'}
      >
        <Typography textStyle={'h2'}>زمان بازدید</Typography>
        <Typography textStyle={'b4'} color={'black-4'}>
          {`${
            culpritTimeSet?.adjuster_visit_date
              ? convertTimestampToShamsi(
                  Number(culpritTimeSet?.adjuster_visit_date),
                )
              : ''
          } 
          ${culpritTimeSet?.adjuster_visit_time ? culpritTimeSet?.adjuster_visit_time : ''}`}
        </Typography>
        <Typography
          cursor={'pointer'}
          display={'flex'}
          alignItems={'center'}
          gap={'2px'}
        >
          <Typography
            textStyle={'b4'}
            color={'purple-2'}
            onClick={() => setOpen(true)}
          >
            تعیین/ ویرایش زمان بازدید
          </Typography>
          <ArrowRightIcon
            className={css({
              position: 'relative',
              top: '2px',
              height: '8px',
              width: '8px',
              strokeWidth: '20px',
            })}
            stroke={token('colors.purple-2')}
          />
        </Typography>
      </Box>
    </Flex>
  );
};

export default VisitTimeSet;
